import { useSearchParams } from "react-router-dom";

import { divider } from "./addStyles";
import ArrowLeft from "./components/ArrowLeft";
import ArrowRight from "./components/ArrowRight";

import { Divider } from "../../ui/Divider/Divider.styled";
import {
  Ellipsis,
  PaginationItem,
  PaginationList,
  Wrapper,
} from "./Pagination.styled";

export const Pagination = ({ totalPages }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentTab = searchParams.get("tab");
  const initialPage = Number(searchParams.get("page")) || 1;

  const handleChangePage = (e, page) => {
    const params = {
      tab: currentTab,
      page,
    };

    setSearchParams(params);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Wrapper>
      <Divider addStyles={divider} />

      <PaginationList
        siblingCount={0}
        count={totalPages}
        page={initialPage}
        onChange={handleChangePage}
        renderItem={item => {
          if (item.type === "start-ellipsis" || item.type === "end-ellipsis") {
            return <Ellipsis>...</Ellipsis>;
          }
          return (
            <PaginationItem
              slots={{ previous: ArrowLeft, next: ArrowRight }}
              {...item}
            />
          );
        }}
      />

      <Divider addStyles={divider} />
    </Wrapper>
  );
};
